module.exports = "https://files.cnvos.lb.djnd.si/static/images/menu-logo-hires-text.png?4cfc75aa01c74e5b1cf1e3aa12e25375";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-logo-hires-text.png
// module id = 70
// module chunks = 1 2